const TASK_STATUSES = {
    CREATED: 'CREATED',
    DONE: 'DONE',
    FAILED: 'FAILED',
    RUNNING: 'RUNNING',
}

export default TASK_STATUSES
